// extracted by mini-css-extract-plugin
export default {"profileLabel":"Resources_profileLabel__0vncm","formWrapper":"Resources_formWrapper__nvXAO","inputField":"Resources_inputField__Z5TQL","error":"Resources_error__WyCqe"};